import "./App.css";
import "./Responsive.css";
import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import { useSelector } from "react-redux";
import axiosInstance from "./axios/axios";
import {
  Route,
  Switch,
  useLocation,
  useHistory,
  Redirect,
} from "react-router-dom";
import "antd/dist/antd.css";
import TopNav from "./components/top_navbar/TopNavbar";
import moment from "moment";
import AccountManagement from "./Modules/SubscriptionRenewal/AccountManagement";
import AccountVerification from "./Modules/SubscriptionRenewal/AccountVerification";
import VerificationDone from "./Modules/SubscriptionRenewal/VerificationDone";
import OtpVerification from "./Modules/SubscriptionRenewal/OtpVerification";
import TwoStepVerification from "./Modules/PreLogin/TwoStepVerification";
import Loader from "./components/popups/Loading";
import useAutoLogout from "./useAutoLogout";
import "./index.css";
import "./components/login/Login.css?v=1.0.1";
import "./components/schedule/styles.css";
import "./components/schedule/Schedule.css";
import "./components/patient/Patient.css";
import "./components/patient/stylesForm.css";
import "./components/billing/Billing.css";
import "./components/popups/Popups.css";
import "./components/report/report.css";
import "./components/setting/setting.css";
import { Decrypt_Value, Encrypt_Value } from "./MiddleWare/EncryptDecrypt";
import EncryptDecryptComp from "./components/schedule/EncryptDecrypt";
import WenoSupport from "./components/popups/WenoSupport";
import { fileTypes, generateFileURL } from "./axios/url.js";
import Aging from "./components/report/Aging.js";
import logout from "./logout.js";
import AccountSetup from "./components/setting/AccountSetup.js";
import AppointmentWaitlist from "./components/schedule/AppointmentWaitlist/index.js";
import UnappliedCreditReport from "./components/report/UnappliedCreditReport.js";
import WriteOffAdjustmentReport from "./components/report/WriteOffAdjustmentReport.js";
import DenialAnalysisReport from "./components/report/DenialAnalysisReport.js";
import PatientGroup from "./components/patient/PatientGroup.js";
import AddClinicalProfile from "./components/popups/AddClinicalProfile";
import StayLoggedIn from "./components/login/StayLoggedIn.js";
import Scoreboard from "./components/patient/OutcomeMeasure/Scoreboard";
import ActivityLog from "./components/patient/OutcomeMeasure/ActivityLog";
import ReNewPage from "./components/login/ReNewPage.js";
import DataExport from "./components/login/DataExport.js";
import UpdatePaymentMethodModal from "./components/popups/UpdatePaymentMethodModal";
import DietRecommendation from "./components/patient/DietRecommendation.js";
import CareSummary from "./components/patient/CareSummary/CareSummary.js";
import { Device } from '@twilio/voice-sdk';
import PhoneCallPopup from "./components/popups/PhoneCallPopup";

if (process.env.NODE_ENV === "production" && window.location.hostname.split(".")[0] !== "production") {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.info = () => {};
  console.debug = () => {};
}

const ClaimSubmissionReport = lazy(
  () => import("./components/report/ClaimSubmissionReport.js"),
);

const PriorAuthorization = lazy(
  () => import("./components/report/PriorAuthorization"),
);
const EligibilityReport = lazy(
  () => import("./components/report/EligibilityReport"),
);
const NotFound = lazy(() => import("./components/setting/InvalidURL.js"));
const BatchEligibility = lazy(
  () => import("./components/patient/BatchEligibility/BatchEligibility"),
);
const AccountReceivableReport = lazy(
  () => import("./components/report/AccountReceivableReport.js"),
);
const OutstandingBalanceReport = lazy(
  () => import("./components/report/OutstandingBalanceReport.js"),
);
const SuperbillReport = lazy(
  () => import("./components/report/SuperbillReport"),
);
const WhatsNew = lazy(() => import("./components/whatsnew/WhatsNewCard.js"));

const AppTemplate = lazy(() => import("./components/schedule/AppTemplate"));
const AppDashboard = lazy(() => import("./components/schedule/AppDashboard"));
const MainDashboard = lazy(() => import("./components/dashboard/Dashboard"));
const PatientFlag = lazy(() => import("./components/patient/PatientFlag"));
const SendErx = lazy(() => import("./components/patient/SendErx"));
const SendErxEdit = lazy(() => import("./components/patient/SendErxEdit"));
const AppProfiles = lazy(() => import("./components/schedule/AppProfiles"));
const BillingProfiles = lazy(
  () => import("./components/schedule/BillingProfiles"),
);
const ReferralManagement = lazy(
  () => import("./Modules/Patient/ReferralManagement"),
);

const PastMedicalHistory = lazy(
  () => import("./Modules/Patient/PastMedicalHistory"),
);
const EpisodeManagement = lazy(
  () => import("./components/patient/EpisodeManagement/EpisodeManagement")
);
const GrowthChart = lazy(() => import("./Modules/Patient/GrowthChart"));

const AuditLog = lazy(() => import("./Modules/Schedule/AuditLog"));
const PracticeDashboard = lazy(
  () => import("./Modules/Schedule/PracticeDashboard"),
);
// const Integrations = lazy(
//   () => import("./components/setting/Integrations/Integrations.js"),
// );
const Tasks = lazy(() => import("./components/popups/Tasks"));

const PatientDashboard = lazy(
  () => import("./components/patient/PatientDashboard"),
);
const Measures = lazy(
  () => import("./components/patient/Measures"),
);
const CardTransactions = lazy(
  () => import("./components/billing/CardTransactions"),
);
const PatientPortalSetting = lazy(
  () => import("./components/setting/PatientPortalSettings"),
);
const PatientList = lazy(() => import("./components/patient/PatientList"));
const Demographics = lazy(() => import("./components/patient/Demographics"));
const InsuranceCoverage = lazy(
  () => import("./components/patient/InsuranceCoverage.js"),
);
const Calender = lazy(() => import("./components/schedule/Calender"));

const Appointment = lazy(() => import("./components/patient/Appointment"));
const EncounterNotes = lazy(() => import("./components/patient/EncounterNotes"));
const Documents = lazy(() => import("./components/patient/Documents"));

const CarePlan = lazy(() => import("./components/patient/CarePlan.js"));
const TreatmentPlan = lazy(
  () => import("./components/patient/TreatmentPlan.js"),
);
const HealthScreening = lazy(
  () => import("./components/patient/HealthScreening/HealthScreening"),
);
const Monitoring = lazy(
  () => import("./components/patient/MonitoringTasks.js"),
);
const Patienttreatmentplanview = lazy(
  () => import("./components/patient/Patienttreatmentplanview"),
);
const Problems = lazy(() => import("./components/patient/Problems"));

const BillingHistory = lazy(
  () => import("./components/patient/BillingHistory"),
);

const NoteTaking = lazy(() => import("./Modules/Patient/NoteTaking"));

const Incomingfax = lazy(
  () => import("./components/patient/IncomingFax/index"),
);
const OutgoingFax = lazy(
  () => import("./components/patient/OutgoingFax/index"),
);
const IncomingFaxindex = lazy(
  () => import("./components/patient/IncomingFax/IncomingFaxindex"),
);
const OutgoingFaxindex = lazy(
  () => import("./components/patient/OutgoingFax/OutgoingFaxindex"),
);
const PatientEducation = lazy(
  () => import("./components/patient/PatientEducation"),
);
const MembershipPlan = lazy(
  () => import("./components/patient/MembershipPlan"),
);
const Allergies = lazy(() => import("./components/patient/Allergies"));
const Medication = lazy(() => import("./components/patient/Medication"));
const ClientPortalAccess = lazy(
  () => import("./components/patient/ClientAccess"),
);
const Lab = lazy(() => import("./components/patient/Lab"));
const FamilyHistory = lazy(() => import("./components/patient/FamilyHistory"));
const Immunization = lazy(() => import("./components/patient/Immunization"));
const EditNotes = lazy(() => import("./components/patient/EditNotes"));
const MedEditNote = lazy(() => import("./components/patient/MedEditNote"));
const ReviewEditNote = lazy(
  () => import("./components/patient/ReviewEditNote"),
);
const MedAllEditNote = lazy(
  () => import("./components/patient/MedAllEditNote"),
);
const PhysicalEditNote = lazy(
  () => import("./components/patient/PhysicalEditNote"),
);
const PlanEditNote = lazy(() => import("./components/patient/PlanEditNote"));
const AssessmentEditNote = lazy(
  () => import("./components/patient/AssessmentEditNote"),
);
const SubjectEditNote = lazy(
  () => import("./components/patient/SubjectEditNote"),
);
const ObjectEditNote = lazy(
  () => import("./components/patient/ObjectEditNote"),
);
const FlowSheet = lazy(
  () => import("./components/patient/FlowSheet/FlowSheet"),
);
const ManageMacroButton = lazy(
  () => import("./components/patient/ManageMacroButtons"),
);
const CaseManagement = lazy(
  () => import("./components/patient/CaseManagement/CaseManagement.js"),
);
const CaseManagementStructure = lazy(
  () => import("./components/patient/CaseManagement/CaseManagementStructure.js"),
);

const LifestyleDietRecommendation = lazy(
  () => import("./components/patient/LifestyleDietRecommendation"),
);
const Orderset = lazy(
  () => import("./components/patient/Orderset/Ordersetdashboard/Orderset.js"),
);

const CreateOrderset = lazy(
  () =>
    import("./components/patient/Orderset/Createneworderset/CreateOrderset.js"),
);
const PreventiveGuidelines = lazy(
  () => import("./components/patient/PreventiveGuidelines"),
);

const ElectronicReports = lazy(
  () => import("./components/patient/ElectronicReports"),
);
const ProcedureOrder = lazy(
  () => import("./components/patient/ProcedureOrder"),
);
const Imaging = lazy(() => import("./Modules/Patient/Imaging/Imaging"));

const ClinicalReport = lazy(() => import("./Modules/Report/ClinicalReport"));
const GroupAttendanceReport = lazy(() => import("./Modules/Report/GroupAttendanceReport"));

const NotificationSettings = lazy(
  () => import("./components/setting/NotificationSettings"),
);

const PatientBillInsurance = lazy(
  () => import("./components/patient/BillandInsurance"),
);
const Previewnote = lazy(() => import("./components/patient/Previewnote"));

const Eob = lazy(() => import("./components/billing/Eob"));

const Era = lazy(() => import("./components/billing/Era"));
const ViewEratable = lazy(() => import("./components/billing/ViewEratable"));

const EobInsurance = lazy(() => import("./components/billing/EobInsurance"));

const PatientPaymentInvoice = lazy(
  () => import("./components/billing/PatientPaymentInvoice"),
);

const EobTableEdit = lazy(() => import("./components/billing/EobTableEdit"));

const ProductProcedure = lazy(
  () => import("./components/report/ProductProcedure"),
);
const RefundReport = lazy(() => import("./components/report/RefundReport"));
const ProductProcedures = lazy(
  () => import("./components/report/ProductProcedures"),
);

const Remittance = lazy(() => import("./components/report/Remittance"));

const Invoice = lazy(() => import("./components/report/Invoice"));

const Appointments = lazy(
  () => import("./components/report/AppointmentReport"),
);

const User = lazy(() => import("./components/report/User"));

const Reminder = lazy(() => import("./components/report/Reminder"));

const PatientReport = lazy(() => import("./components/report/PatientReport"));

const RejectionAnalysisReport = lazy(
  () => import("./components/report/RejectionAnalysisReport.js"),
);

const DaySheet = lazy(() => import("./components/report/DaySheet"));

const BillingSummary = lazy(() => import("./components/report/BillingSummary"));

const ProductivityReport = lazy(
  () => import("./components/report/ProductivityReport"),
);

const OutgoingPrescription = lazy(
  () => import("./components/report/OutgoingPrescription"),
);

const IncomeAllocationReport = lazy(
  () => import("./components/report/IncomeAllocationReport"),
);

const InsuranceClaim = lazy(
  () => import("./components/billing/InsuranceClaim"),
);

const GenerateForm = lazy(
  () => import("./components/billing/GenerateClaimProcess"),
);

const Dataimport = lazy(() => import("./components/setting/Dataimport"));

const PatientPayment = lazy(
  () => import("./components/billing/PatientPayment"),
);

const PatientStatement = lazy(
  () => import("./components/billing/PatientStatement"),
);

const FeeSchedule = lazy(() => import("./components/billing/FeeSchedule"));

const PatientBalance = lazy(
  () => import("./components/billing/PatientBalance"),
);

// const DenialAnalysis = lazy(() =>
//   import("./components/billing/DenialAnalysis")
// );

const SettingsMyProfile = lazy(
  () => import("./components/setting/SettingsMyProfile"),
);

const SettingPracticeInfo = lazy(
  () => import("./components/setting/SettingPracticeInfo"),
);

const Users = lazy(() => import("./components/setting/Users"));

const RolesMain = lazy(() => import("./components/setting/RolesMain"));

const Security = lazy(() => import("./components/setting/Security"));

const MyPlan = lazy(() => import("./components/setting/MyPlanNew"));

const SecurityDocument = lazy(
  () => import("./components/setting/SecurityDocument"),
);

const SettingBilling = lazy(
  () => import("./components/setting/SettingBilling"),
);

const SettingService = lazy(
  () => import("./components/setting/SettingService"),
);

const PayerSearch = lazy(() => import("./components/setting/PayerSearch"));

const CalenderSettings = lazy(
  () => import("./components/setting/CalenderSettings"),
);

const TimeZoneSettings = lazy(
  () => import("./components/setting/TimeZoneSetting"),
);

const OnlineScheduleSettings = lazy(
  () => import("./components/setting/OnlineScheduleSettings/index"),
);

const AppointmentReminder = lazy(
  () => import("./components/setting/AppointmentReminder"),
);

const ERXSetting = lazy(() => import("./components/setting/ERXSetting"));

const Inventory = lazy(() => import("./components/setting/Inventory"));

const Templates = lazy(() => import("./components/setting/Templates"));

const LabSettings = lazy(() => import("./components/setting/Lab"));

const Login = lazy(() => import("./components/login/Login"));
const ReActivate = lazy(() => import("./components/login/ReActivate.js"));

const AccessDenied = lazy(() => import("./components/setting/AccessDenied"));

const Acknowledgement = lazy(
  () => import("./components/setting/Acknowledgement"),
);

const SubscriptionExpired = lazy(
  () => import("./components/popups/SubscriptionExpired"),
);

// const DeleteAccount = lazy(() => import("./components/setting/DeleteAccount"));
const DeleteAccountMain = lazy(
  () => import("./components/setting/DeleteAccountMain/index.js"),
);
const SecureData = lazy(() => import("./components/setting/SecureData"));

const UpgradeRequired = lazy(
  () => import("./components/popups/UpgradeRequired"),
);

const ForgotPassword = lazy(() => import("./components/login/ForgotPassword"));

const CheckYourEmail = lazy(() => import("./components/login/CheckYourEmail"));

const SetNewPassword = lazy(() => import("./components/login/SetNewPassword"));

const ResetSuccessfull = lazy(
  () => import("./components/login/ResetSuccessfull"),
);

const Integrations = lazy(
  () => import("./components/setting/Integrations/Integrations.js"),
);

const App = () => {
  const [showUpdatePaymentModal, setShowUpdatePaymentModal] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupStep, setPopupStep] = useState(0);
  let location_path = useLocation();
  const [sendToContinue, setSendToContinue] = useState("");

  let history = useHistory();
  const isAuthPage =
    location_path.pathname.startsWith("/login") ||
    location_path.pathname === "/twostepverify";
  const token = localStorage.getItem("token");
  var storedNames = localStorage.getItem("roles");
  var expired_days =
    localStorage.getItem("expired_days") &&
    Decrypt_Value(localStorage.getItem("expired_days"), "vozo");

  var temp_user =
    localStorage.getItem("temp_user") &&
    JSON.parse(localStorage.getItem("temp_user").toLowerCase());
  var twoStepVerify =
    localStorage.getItem("twoStepVerify") &&
    Decrypt_Value(localStorage.getItem("twoStepVerify"), "vozo");

  const [base64, setBase64] = useState("");
  const [notesData, setNotesData] = useState([]);
  const [extension, setExtension] = useState("");
  const [idletime, setIdletime] = useState("");
  const [showWhatsNew, setShowWhatsNew] = useState(false);
  const [whatsNewId, setWhatsNewId] = useState("");
  const [popupKey, setPopupKey] = useState("");
  const [popupType, setPopupType] = useState("");
  const [buttonText, setButtonText] = useState("Navigate");
  const [link, setlink] = useState("");
  const [title, settittle] = useState("");
  const [description, setDescription] = useState("");
  const whatsNewTimerRef = useRef(null);
  if (storedNames) {
    storedNames = JSON.parse(
      JSON.stringify(Decrypt_Value(storedNames, "vozo")),
    );
  } else {
    storedNames = [];
  }
  const allowedDomains = [
    "production",
    "saravana",
    "westridgehealthconsultingllc",
    "classicmedicine",
    "theorthopediccenterofnacogdoches",
    "vcphd",
    "cthibaultnpconciergedirectprimarycare",
    "associatesinintegratedhealth",
    "refreshhealthandwellness",
    "virginiapainandrestorativehealth",
  ];

  const whatsNewRoutes = {
    TREATMENT_PLAN: {
      path: "/patient/treatmentplan",
      requiresPid: true,
    },
    APPOINTMENT_WAITLIST: {
      path: "/schedule/waitlist",
      requiresPid: false,
    },
    BATCH_ELIGIBILITY: {
      path: "/patient/BatchEligibility",
      requiresPid: false,
    },
    GOOD_FAITH_ESTIMATE: {
      path: "/patient/insuranceCoverage",
      requiresPid: true,
      query: "?tab=goodFaithEstimate",
    },
    SUPERBILLS: {
      path: "/report/superbillreport",
      requiresPid: false,
    },
    GROUP_PATIENT_APPOINTMENT: {
      path: "/patient/patientGroup",
      requiresPid: false,
    },
    DEDICATED_DASHBOARD: {
      path: "/dashboard",
      requiresPid: false,
    },
    DPC_MEMBERSHIP: {
      path: "/patient/demographics",
      requiresPid: true,
    },
    CARE_PLAN: {
      path: "/patient/careplan",
      requiresPid: true,
    },
    CALENDAR_SYNC: {
      path: "/settings/integrations",
      requiresPid: false,
    },
    THIRD_PARTY_INTEGRATION: {
      path: "/settings/integrations",
      requiresPid: false,
    },
    PDMP_PRESCRIPTION: {
      path: "/settings/myplan",
      requiresPid: false,
    },
    LAB_LAB_ORDERS: {
      path: "/settings/lab",
      requiresPid: false,
    },
    SENDING_INTAKE_FORMS: {
      path: "/patient/documents",
      requiresPid: true,
    },
    VITAL_MONITORING_GRAPH: {
      path: "/patient/patientdashboard",
      requiresPid: true,
    },
    MEASUREMENT_BASED_CARE: {
      path: "/patient/documents",
      requiresPid: true,
    },
    BILLING_REPORTS: {
      path: "/report/ClaimSubmissionReport",
      requiresPid: false,
    },
    ACCOUNT_CANCELLATION_REACTIVATION: {
      path: "/settings/myplan",
      requiresPid: false,
    },
    FLOWSHEET: {
      path: "/patient/flowsheet",
      requiresPid: true,
    },
    PATIENT_CARE_CHECKLIST: {
      path: "/patient/demographics",
      requiresPid: true,
    },
    LIFESTYLE_DIET_RECOMMENDATION: {
      path: "/patient/demographics",
      requiresPid: true,
    },
    GROWTH_CHART: {
      path: "/patient/growthchart",
      requiresPid: true,
    },
    IMAGING_ORDERS: {
      path: "/patient/imaging",
      requiresPid: true,
    },
    SCHEDULING_WIDGET: {
      path: "/settings/onlineschedule",
      requiresPid: false,
    },
    PATIENT_CARE_SUMMARY: {
      path: "/patient/careSummary",
      requiresPid: true,
    },
  };

  const getPidFromPath = (pathname = "") => {
    const match = pathname.match(/^\/patient\/[^/]+\/([^/?#]+)/);
    const pid = match && match[1] ? match[1] : "";

    if (!pid || pid === "null" || pid === "undefined") {
      return "";
    }

    return pid;
  };

  const DEFAULT_WHATS_NEW_PATIENT_ID = "1";

  const getPatientIdFromPath = () => {
    const currentPid = getPidFromPath(location_path.pathname);

    if (currentPid) {
      return currentPid;
    }

    const locationState = location_path?.state || {};
    const locationData = location_path?.data || {};

    const statePid =
      locationState.pid ||
      locationState.patient_id ||
      locationState.patientId ||
      locationData.pid ||
      locationData.patient_id ||
      locationData.patientId ||
      "";

    if (statePid && statePid !== "null" && statePid !== "undefined") {
      return statePid;
    }

    const statePath =
      locationState.pathname ||
      locationState.path ||
      locationState.fromPath ||
      locationState.redirectPath ||
      locationData.pathname ||
      locationData.path ||
      locationData.fromPath ||
      locationData.redirectPath ||
      "";

    const pathPid = getPidFromPath(statePath);

    if (pathPid) {
      return pathPid;
    }

    return DEFAULT_WHATS_NEW_PATIENT_ID;
  };

  const getWhatsNewRedirectPath = (key) => {
    const popupKey = String(key || "")
      .trim()
      .toUpperCase();

    if (
      popupKey === "GOOD_FAITH_ESTIMATE" ||
      popupKey === "GOOD_FAITH_ESTIMATES" ||
      popupKey === "GOOD_FAITH"
    ) {
      const pid = getPatientIdFromPath();

      if (pid) {
        return {
          pathname: `/patient/insuranceCoverage/${pid}`,
          search: "?tab=goodFaithEstimate",
          state: {
            fromWhatsNew: true,
            whatsNewPopupKey: "GOOD_FAITH_ESTIMATE",
            whatsNewTab: "goodFaithEstimate",
            activeInsuranceTab: "5",
          },
          data: {
            fromWhatsNew: true,
            whatsNewPopupKey: "GOOD_FAITH_ESTIMATE",
            whatsNewTab: "goodFaithEstimate",
            activeInsuranceTab: "5",
          },
        };
      }

      return {
        pathname: "/patient/patientlist",
        state: {
          fromWhatsNew: true,
          whatsNewPopupKey: "GOOD_FAITH_ESTIMATE",
          afterPatientSelect: "GOOD_FAITH_ESTIMATE",
          whatsNewTab: "goodFaithEstimate",
          activeInsuranceTab: "5",
        },
        data: {
          fromWhatsNew: true,
          whatsNewPopupKey: "GOOD_FAITH_ESTIMATE",
          afterPatientSelect: "GOOD_FAITH_ESTIMATE",
          whatsNewTab: "goodFaithEstimate",
          activeInsuranceTab: "5",
        },
      };
    }

    if (popupKey === "DPC_MEMBERSHIP") {
      const pid = getPatientIdFromPath();

      if (pid) {
        return {
          pathname: `/patient/demographics/${pid}/`,
          search: "?tab=dpcMembership",
          state: {
            fromWhatsNew: true,
            whatsNewPopupKey: "DPC_MEMBERSHIP",
            whatsNewTab: "dpcMembership",
            activeTab: "2",
            activeDemographicsTab: "2",
          },
          data: {
            fromWhatsNew: true,
            whatsNewPopupKey: "DPC_MEMBERSHIP",
            whatsNewTab: "dpcMembership",
            activeTab: "2",
            activeDemographicsTab: "2",
          },
        };
      }

      return {
        pathname: "/patient/patientlist",
        state: {
          fromWhatsNew: true,
          whatsNewPopupKey: "DPC_MEMBERSHIP",
          afterPatientSelect: "DPC_MEMBERSHIP",
          whatsNewTab: "dpcMembership",
          activeTab: "2",
          activeDemographicsTab: "2",
        },
        data: {
          fromWhatsNew: true,
          whatsNewPopupKey: "DPC_MEMBERSHIP",
          afterPatientSelect: "DPC_MEMBERSHIP",
          whatsNewTab: "dpcMembership",
          activeTab: "2",
          activeDemographicsTab: "2",
        },
      };
    }

    if (popupKey === "CARE_PLAN") {
      const pid = getPatientIdFromPath();

      if (pid) {
        return {
          pathname: `/patient/careplan/${pid}`,
          state: {
            fromWhatsNew: true,
            whatsNewPopupKey: "CARE_PLAN",
          },
          data: {
            fromWhatsNew: true,
            whatsNewPopupKey: "CARE_PLAN",
          },
        };
      }

      return {
        pathname: "/patient/patientlist",
        state: {
          fromWhatsNew: true,
          whatsNewPopupKey: "CARE_PLAN",
          afterPatientSelect: "CARE_PLAN",
        },
        data: {
          fromWhatsNew: true,
          whatsNewPopupKey: "CARE_PLAN",
          afterPatientSelect: "CARE_PLAN",
        },
      };
    }

    if (popupKey === "SENDING_INTAKE_FORMS") {
      const pid = getPatientIdFromPath();

      if (pid) {
        return {
          pathname: `/patient/documents/${pid}`,
          search: "?tab=1",
          state: {
            fromWhatsNew: true,
            whatsNewPopupKey: "SENDING_INTAKE_FORMS",
            whatsNewTab: "documents",
            activeDocumentsTab: "1",
          },
          data: {
            fromWhatsNew: true,
            whatsNewPopupKey: "SENDING_INTAKE_FORMS",
            whatsNewTab: "documents",
            activeDocumentsTab: "1",
          },
        };
      }

      return {
        pathname: "/patient/patientlist",
        state: {
          fromWhatsNew: true,
          whatsNewPopupKey: "SENDING_INTAKE_FORMS",
          afterPatientSelect: "SENDING_INTAKE_FORMS",
          whatsNewTab: "documents",
          activeDocumentsTab: "1",
        },
        data: {
          fromWhatsNew: true,
          whatsNewPopupKey: "SENDING_INTAKE_FORMS",
          afterPatientSelect: "SENDING_INTAKE_FORMS",
          whatsNewTab: "documents",
          activeDocumentsTab: "1",
        },
      };
    }

    if (popupKey === "VITAL_MONITORING_GRAPH") {
      const pid = getPatientIdFromPath();

      if (pid) {
        return {
          pathname: `/patient/patientdashboard/${pid}`,
          state: {
            fromWhatsNew: true,
            whatsNewPopupKey: "VITAL_MONITORING_GRAPH",
          },
          data: {
            fromWhatsNew: true,
            whatsNewPopupKey: "VITAL_MONITORING_GRAPH",
          },
        };
      }

      return {
        pathname: "/patient/patientlist",
        state: {
          fromWhatsNew: true,
          whatsNewPopupKey: "VITAL_MONITORING_GRAPH",
          afterPatientSelect: "VITAL_MONITORING_GRAPH",
        },
        data: {
          fromWhatsNew: true,
          whatsNewPopupKey: "VITAL_MONITORING_GRAPH",
          afterPatientSelect: "VITAL_MONITORING_GRAPH",
        },
      };
    }

    const patientWhatsNewRouteMap = {
      GOOD_FAITH_ESTIMATE: {
        pathname: (pid) => `/patient/insuranceCoverage/${pid}`,
        search: "?tab=goodFaithEstimate",
        state: {
          whatsNewTab: "goodFaithEstimate",
          activeInsuranceTab: "5",
        },
      },

      DPC_MEMBERSHIP: {
        pathname: (pid) => `/patient/demographics/${pid}/`,
        search: "?tab=2",
        state: {
          whatsNewTab: "dpcMembership",
          activeTab: "2",
          activeDemographicsTab: "2",
        },
      },

      CARE_PLAN: {
        pathname: (pid) => `/patient/careplan/${pid}`,
      },

      SENDING_INTAKE_FORMS: {
        pathname: (pid) => `/patient/documents/${pid}`,
        search: "?tab=1",
        state: {
          whatsNewTab: "documents",
          activeDocumentsTab: "1",
        },
      },

      MEASUREMENT_BASED_CARE: {
        pathname: (pid) => `/patient/documents/${pid}`,
        search: "?tab=3",
        state: {
          whatsNewTab: "outcomeMeasures",
          activeDocumentsTab: "3",
        },
      },

      VITAL_MONITORING_GRAPH: {
        pathname: (pid) => `/patient/patientdashboard/${pid}`,
      },

      TREATMENT_PLAN: {
        pathname: (pid) => `/patient/treatmentplan/${pid}`,
      },

      FLOWSHEET: {
        pathname: (pid) => `/patient/flowsheet/${pid}`,
      },

      PATIENT_CARE_CHECKLIST: {
        pathname: (pid) => `/patient/demographics/${pid}/`,
        search: "?tab=8",
        state: {
          whatsNewTab: "careChecklist",
          activeTab: "8",
          activeDemographicsTab: "8",
        },
      },

      LIFESTYLE_DIET_RECOMMENDATION: {
        pathname: (pid) => `/patient/demographics/${pid}/`,
        search: "?tab=6",
        state: {
          whatsNewTab: "lifestyleDietRecommendation",
          activeTab: "6",
          activeDemographicsTab: "6",
        },
      },

      GROWTH_CHART: {
        pathname: (pid) => `/patient/growthchart/${pid}`,
      },

      IMAGING_ORDERS: {
        pathname: (pid) => `/patient/imaging/${pid}`,
      },

      PATIENT_CARE_SUMMARY: {
        pathname: (pid) => `/patient/careSummary/${pid}/`,
      },
    };

    const patientWhatsNewRoute = patientWhatsNewRouteMap[popupKey];

    if (patientWhatsNewRoute) {
      const pid = getPatientIdFromPath();

      if (pid) {
        return {
          pathname: patientWhatsNewRoute.pathname(pid),
          search: patientWhatsNewRoute.search || "",
          state: {
            fromWhatsNew: true,
            whatsNewPopupKey: popupKey,
            ...(patientWhatsNewRoute.state || {}),
          },
          data: {
            fromWhatsNew: true,
            whatsNewPopupKey: popupKey,
            ...(patientWhatsNewRoute.state || {}),
          },
        };
      }

      return {
        pathname: "/patient/patientlist",
        state: {
          fromWhatsNew: true,
          whatsNewPopupKey: popupKey,
          afterPatientSelect: popupKey,
          ...(patientWhatsNewRoute.state || {}),
        },
        data: {
          fromWhatsNew: true,
          whatsNewPopupKey: popupKey,
          afterPatientSelect: popupKey,
          ...(patientWhatsNewRoute.state || {}),
        },
      };
    }

    const routeConfig = whatsNewRoutes[popupKey];

    if (!routeConfig) {
      return "";
    }

    const appendQuery = (path) => {
      return routeConfig.query ? `${path}${routeConfig.query}` : path;
    };

    if (!routeConfig.requiresPid) {
      return appendQuery(routeConfig.path);
    }

    const pid = getPatientIdFromPath();

    if (!pid) {
      return "/patient/patientlist";
    }

    if (
      routeConfig.path === "/patient/demographics" ||
      routeConfig.path === "/patient/careSummary"
    ) {
      return appendQuery(`${routeConfig.path}/${pid}/`);
    }

    return appendQuery(`${routeConfig.path}/${pid}`);
  };

  useEffect(() => {
    if (!token) return;

    const subdomain = window.location.hostname.split(".")[0];

    const showPopup = localStorage.getItem("show_update_payment_popup") === "1";

    const owner_id =
      localStorage.getItem("owner_id") &&
      Decrypt_Value(localStorage.getItem("owner_id"), "vozo");

    const isOwnerNull = !owner_id || owner_id === "" || owner_id === "null";

    const today = new Date().toISOString().split("T")[0];
    const lastShownDate = localStorage.getItem("payment_popup_date");

    const shouldShowToday = lastShownDate !== today;

    if (
      allowedDomains.includes(subdomain) &&
      showPopup &&
      isOwnerNull &&
      shouldShowToday
    ) {
      setShowUpdatePaymentModal(true);

      localStorage.setItem("payment_popup_date", today);
    } else {
      setShowUpdatePaymentModal(false);
    }
  }, [token]);
  const idleTimer = useSelector((state) => state.Setting.idleTimer);

  useEffect(() => {
    setIdletime(localStorage.getItem("idle"));
  }, [idleTimer]);

  useEffect(() => {
    const subdomain = window.location.hostname.split(".")[0];
    if (subdomain === "sunnysidecomprehensivecarepllc") {
      localStorage.setItem("dateFormat", "MM/DD/YYYY");
    }
  }, []);

  const idleinMin = parseInt(idletime) / 60;
  const {
    timer,
    showSessionModal,
    popupSeconds,
    refreshToken,
    setShowSessionModal,
  } = useAutoLogout(parseInt(idleinMin));

  const [s_role, sets_role] = useState([]);
  const [account, setAccount] = useState("");
  const [trial, setTrial] = useState("");

  const [iframesrc, setIframeSrc] = useState("");
  const [noteLock, setNoteLock] = useState("");
  const [notedate, setNoteDate] = useState("");
  const [notedata, setNoteData] = useState([]);
  const [notedata1, setNoteData1] = useState([]);
  const [noteid, setNoteid] = useState("");
  const [nottime, setNoteTime] = useState("");
  const [noteinfo, setNoteInfo] = useState("");
  const ConfToken = localStorage.getItem("invoname")
    ? localStorage.getItem("invoname")
    : undefined;

  const SettingRef = useRef();
  const userid =
    localStorage.getItem("user_id") &&
    Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const dbHost =
    localStorage.getItem("DBHost") &&
    Decrypt_Value(localStorage.getItem("DBHost"), "vozo");
  const [TasksRef, setTaskRef] = useState(0);

  const TopNavTasks = () => {
    setTaskRef((pre) => pre + 1);
  };

  const TopNavProps = () => {
    SettingRef.current.dataFetch();
  };

  const [mailAddress, setMailAddress] = useState("");
  const [reqDrop, setReqDrop] = useState(false);
  const [calRefresh, setCalRefresh] = useState(false);
  const [refid, setRefId] = useState("");
  var rememberMe =
    localStorage.getItem("auto_login") &&
    Decrypt_Value(localStorage.getItem("auto_login"), "vozo");

  const handleDropReq = () => {
    if (!reqDrop) {
      setRefId("");
    }
    setReqDrop(!reqDrop);
  };

  const handleRefCalls = () => {
    setCalRefresh(!calRefresh);
  };

  const handleframesrc = (a) => {
    setIframeSrc(a);
  };
  const handleNotesData = (b, c, d, e, f, g) => {
    setNoteDate(b);
    setNoteData(c);
    setNoteData1(d);
    setNoteid(e);
    setNoteTime(f);
    setNoteInfo(g);
  };

  const [refreshList, setRefreshList] = useState(true);

  // ==================== TWILIO VOICE STATE ====================
  const [twilioDevice, setTwilioDevice] = useState(null);
  const [phoneCallPopupData, setPhoneCallPopupData] = useState(null);
  // phoneCallPopupData shape: { callType, incomingCall, patientName, phoneNumber }

  const twilioDeviceRef = useRef(null);

  // Initialize Twilio Device once when App loads
  useEffect(() => {
    const rawUserId = localStorage.getItem("user_id");
    if (!rawUserId) return; // Don't initialize if not logged in
    const userId = Decrypt_Value(rawUserId, "vozo");

    const initTwilioDevice = async (force = false) => {
      // If device already exists and is not destroyed, and we are not forcing a re-init, skip
      if (!force && twilioDeviceRef.current && twilioDeviceRef.current.state !== 'destroyed') {
        return;
      }

      if (force && twilioDeviceRef.current && twilioDeviceRef.current.state !== 'destroyed') {
        //console.log('APP_JS: Destroying old Twilio Device before re-initializing...');
        twilioDeviceRef.current.destroy();
        twilioDeviceRef.current = null;
        setTwilioDevice(null);
      }

      //console.log('APP_JS: Starting initTwilioDevice. Fetching token...');
      try {
        const response = await axiosInstance.get(`/vozo/twilio/get-token?uid=${userId}&_t=${new Date().getTime()}`);
        //console.log('APP_JS: Token response received:', response.data);
        let twilioToken = response.data?.token;
        if (!twilioToken && response.data) {
          try {
            // Check if it's an encrypted string or an object
            let parsed = response.data;
            if (typeof response.data === 'string') {
              try {
                parsed = Decrypt_Value(response.data, "vozo");
              } catch (err) {
                parsed = JSON.parse(response.data);
              }
            }
            twilioToken = parsed.token;
          } catch (e) { }
        }

        if (twilioToken) {
          //console.log('APP_JS: Token parsed successfully. Creating new Device instance...');
          const newDevice = new Device(twilioToken, {
            codecPreferences: ['opus', 'pcmu'],
            fakeLocalDTMF: true,
            enableRingingState: true
          });

          //console.log('APP_JS: Registering device...');
          await newDevice.register();

          twilioDeviceRef.current = newDevice;
          setTwilioDevice(newDevice);
          //console.log('APP_JS: Twilio Device registered successfully! State:', newDevice.state);

          // Listen for incoming calls
          newDevice.on('incoming', (call) => {
            //console.log('APP_JS: Incoming call event from:', call.parameters.From);
            
            // Extract custom patient name if backend sent it via TwiML <Parameter>
            let customPatientName = '';
            if (call.customParameters && typeof call.customParameters.get === 'function') {
               customPatientName = call.customParameters.get('patientName');
               //console.log('APP_JS: Custom patient name from TwiML:', customPatientName);
            }
            
            setPhoneCallPopupData({
              callType: 'incoming',
              incomingCall: call,
              patientName: customPatientName || call.parameters.From || 'Unknown Caller',
              phoneNumber: call.parameters.From || ''
            });
          });

          newDevice.on('destroyed', () => {
            //console.log('APP_JS: Twilio Device was destroyed!');
          });

          newDevice.on('tokenWillExpire', async () => {
            //console.log('APP_JS: Twilio Token is about to expire! Fetching a new one in the background...');
            try {
              const res = await axiosInstance.get(`/vozo/twilio/get-token?uid=${userId}&_t=${new Date().getTime()}`);
              let newToken = res.data?.token;
              if (!newToken && res.data) {
                let parsed = res.data;
                if (typeof res.data === 'string') {
                  try {
                    parsed = Decrypt_Value(res.data, "vozo");
                  } catch (err) {
                    parsed = JSON.parse(res.data);
                  }
                }
                newToken = parsed.token;
              }
              if (newToken) {
                newDevice.updateToken(newToken);
                //console.log('APP_JS: Twilio Token successfully updated before expiration!');
              }
            } catch (err) {
              //console.error('APP_JS: Failed to refresh Twilio token:', err);
            }
          });
          newDevice.on('unregistered', () => {
            //console.log('APP_JS: Twilio Device was unregistered!');
          });
        } else {
          //console.log('APP_JS: No valid token found in response.');
        }
      } catch (error) {
        //console.error('APP_JS: Failed to initialize Twilio Device:', error);
      }
    };

    initTwilioDevice();
    
    // Listen for re-initialization events (e.g. after adding credentials)
    const handleReinit = () => initTwilioDevice(true);
    window.addEventListener('reinit-twilio-device', handleReinit);

    // NOTE: We intentionally do NOT destroy the device in cleanup.
    // React Strict Mode runs effects twice, and destroying the device
    // on cleanup would break the connection.
    return () => window.removeEventListener('reinit-twilio-device', handleReinit);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Listen for outgoing call events from EditSchedule (or anywhere)
  useEffect(() => {
    const handleOutgoingCall = (e) => {
      //console.log('APP_JS: Outgoing call event received!', e.detail);
      const { phoneNumber, patientName, appointmentId, patientId, providerId } = e.detail;
      //console.log('APP_JS: Setting phoneCallPopupData to trigger popup render. Current twilioDevice state:', twilioDeviceRef.current ? twilioDeviceRef.current.state : 'null');

      setPhoneCallPopupData({
        callType: 'outgoing',
        incomingCall: null,
        patientName: patientName || 'Patient',
        phoneNumber: phoneNumber || '',
        appointmentId: appointmentId || '',
        patientId: patientId || '',
        providerId: providerId || ''
      });
    };

    window.addEventListener('start-outgoing-call', handleOutgoingCall);
    return () => {
      window.removeEventListener('start-outgoing-call', handleOutgoingCall);
    };
  }, []);

  // Close the phone call popup
  const closePhoneCallPopup = () => {
    setPhoneCallPopupData(null);
  };
  // ==================== END TWILIO VOICE ====================

  const hideTopNavbar = useSelector(
    (state) => state.ScheduleWidget.inputValue.hideTopNavbar,
  );
  const refreshPatient = () => {
    setRefreshList(!refreshList);
  };

  const handleNotesLock = (x) => {
    setNoteLock(x);
  };

  useEffect(() => {
    if (rememberMe && location_path.pathname !== "/") {
      let path_encrypted = Encrypt_Value(location_path.pathname, "vozo");
      localStorage.setItem("last_location", path_encrypted);
    }
  }, [location_path]);

  useEffect(() => {
    let last_path =
      localStorage.getItem("last_location") &&
      Decrypt_Value(localStorage.getItem("last_location"), "vozo");

    if (rememberMe && last_path !== null && last_path !== "/null") {
      history.push(`${last_path}`);
    }

    var uid =
      localStorage.getItem("user_id") &&
      Decrypt_Value(localStorage.getItem("user_id"), "vozo");

    var appt1 = false;
    var viewAuditLog = false;
    var accessPracticeDashboard = false;
    var setProviderAvailability = false;
    var manageAppointment_BillingProfile = false;

    // settings
    var manageAccountSettings = false;
    var configureBillingServices = false;
    var setSchedulingPreferences = false;
    var manageAdministrationSettings = false;

    // patient
    var managePatientEducation = false;
    let processCardTransactions = false;
    //reports
    var rep1 = false;
    var rep2 = false;
    var rep3 = false;

    var demo = false;
    var appt = false;
    var mesg = false;
    var notes = false;
    var drugs = false;
    var bill = false;
    var coding = false;
    var rep = false;
    var bill_a = false;
    var pat_bal = false;

    var users = false;
    var users_s = false;
    var bill_admin = false;
    var acl = false;
    var pat_statement = false;
    var bill_led = false;
    var notes_lock = false;
    var appt_a = false;
    var ipad = false;
    var erx = false;

    var contacts = false;
    var pat_g = false;
    var pat_analytics = false;
    var gadd = false;
    var pat_share = false;
    var pat_emergency = false;
    var m_templete = false;
    var ins_claims = false;
    var gm = false;

    var bill_s = false;
    var finance_reports = false;
    var ref_source = false;
    var practice_groups = false;
    var patient_referral = false;
    var show_notification = false;
    var fax = false;

    // viewOnly variable

    let managePatientEducation_viewOnly = false;
    let accessPracticeDashboard_viewOnly = false;
    let setProviderAvailability_viewOnly = false;
    let manageAppointment_BillingProfile_viewOnly = false;
    let postPayments_viewOnly = false;
    let postPayments = false;

    let processCardTransactions_viewOnly = false;
    let rep2_viewOnly = false;
    let rep3_viewOnly = false;
    let manageAccountSettings_viewOnly = false;
    let configureBillingServices_viewOnly = false;
    let viewAuditLog_viewOnly = false;

    let setSchedulingPreferences_viewOnly = false;
    let manageAdministrationSettings_viewOnly = false;
    let fax_perm_viewOnly = false;
    let patientRef_viewOnly = false;
    let show_noti_viewOnly = false;
    let m_templete1_viewOnly = false;
    let pat_g1_viewOnly = false;
    let contacts1_viewOnly = false;
    let appt_a1_viewOnly = false;
    let notes_lock1_viewOnly = false;
    let bill_led1_viewOnly = false;
    let pat_statement1_viewOnly = false;
    let bill_a1_viewOnly = false;
    let rep1_viewOnly = false;
    let coding1_viewOnly = false;

    let ins_claims1_viewOnly = false;
    let notes1_viewOnly = false;
    let mesg1_viewOnly = false;
    let appt1_viewOnly = false;
    let demo1_viewOnly = false;

    if (storedNames != null) {
      for (let i = 0; i < storedNames.length; i++) {
        //new start

        //viewOnly
        //schedule

        // schedule module
        if (
          storedNames[i].value === "appt_v" ||
          storedNames[i].value === "appt_v_viewOnly"
        ) {
          appt = true;
        }
        if (
          storedNames[i].value === "accessPracticeDashboard" ||
          storedNames[i].value === "accessPracticeDashboard_viewOnly"
        ) {
          accessPracticeDashboard = true;
        }
        if (
          storedNames[i].value === "setProviderAvailability" ||
          storedNames[i].value === "setProviderAvailability_viewOnly"
        ) {
          setProviderAvailability = true;
        }
        if (
          storedNames[i].value === "manageAppointment_BillingProfile" ||
          storedNames[i].value === "manageAppointment_BillingProfile_viewOnly"
        ) {
          manageAppointment_BillingProfile = true;
        }
        if (
          storedNames[i].value === "viewAuditLog" ||
          storedNames[i].value === "viewAuditLog_viewOnly"
        ) {
          viewAuditLog = true;
        }

        if (storedNames[i].value === "appt_v_viewOnly") {
          appt1_viewOnly = true;
        }
        if (storedNames[i].value === "accessPracticeDashboard_viewOnly") {
          accessPracticeDashboard_viewOnly = true;
        }
        if (storedNames[i].value === "setProviderAvailability_viewOnly") {
          setProviderAvailability_viewOnly = true;
        }
        if (
          storedNames[i].value === "manageAppointment_BillingProfile_viewOnly"
        ) {
          manageAppointment_BillingProfile_viewOnly = true;
        }
        if (storedNames[i].value === "viewAuditLog_viewOnly") {
          viewAuditLog_viewOnly = true;
        }

        //reports
        if (storedNames[i].value === "rep_v_viewOnly") {
          rep1_viewOnly = true;
        }
        if (storedNames[i].value === "rep_v_2_viewOnly") {
          rep2_viewOnly = true;
        }
        if (storedNames[i].value === "rep_v_3_viewOnly") {
          rep3_viewOnly = true;
        }

        //billing

        //other functionality
        if (storedNames[i].value === "pat_g_viewOnly") {
          pat_g1_viewOnly = true;
        }
        if (storedNames[i].value === "appt_a_viewOnly") {
          appt_a1_viewOnly = true;
        }
        if (storedNames[i].value === "fax_viewOnly") {
          fax_perm_viewOnly = true;
        }
        if (storedNames[i].value === "show_notification_viewOnly") {
          show_noti_viewOnly = true;
        }
        if (storedNames[i].value === "mesg_viewOnly") {
          mesg1_viewOnly = true;
        }

        //fullAccess

        // settings
        if (
          storedNames[i].value === "manageAccountSettings" ||
          storedNames[i].value === "manageAccountSettings_viewOnly"
        ) {
          manageAccountSettings = true;
        }
        if (
          storedNames[i].value === "configureBillingServices" ||
          storedNames[i].value === "configureBillingServices_viewOnly"
        ) {
          configureBillingServices = true;
        }
        if (
          storedNames[i].value === "setSchedulingPreferences" ||
          storedNames[i].value === "setSchedulingPreferences_viewOnly"
        ) {
          setSchedulingPreferences = true;
        }

        if (
          storedNames[i].value === "manageAdministrationSettings" ||
          storedNames[i].value === "manageAdministrationSettings_viewOnly"
        ) {
          manageAdministrationSettings = true;
        }
        // settings
        if (storedNames[i].value === "manageAccountSettings_viewOnly") {
          manageAccountSettings_viewOnly = true;
        }
        if (storedNames[i].value === "configureBillingServices_viewOnly") {
          configureBillingServices_viewOnly = true;
        }
        if (storedNames[i].value === "setSchedulingPreferences_viewOnly") {
          setSchedulingPreferences_viewOnly = true;
        }
        if (storedNames[i].value === "manageAdministrationSettings_viewOnly") {
          manageAdministrationSettings_viewOnly = true;
        }

        //patient
        if (
          storedNames[i].value === "managePatientEducation" ||
          storedNames[i].value === "managePatientEducation_viewOnly"
        ) {
          managePatientEducation = true;
        }
        //patient
        if (storedNames[i].value === "demo_v_viewOnly") {
          demo1_viewOnly = true;
        }
        if (storedNames[i].value === "contacts_viewOnly") {
          contacts1_viewOnly = true;
        }
        if (storedNames[i].value === "managePatientEducation_viewOnly") {
          managePatientEducation_viewOnly = true;
        }
        if (storedNames[i].value === "notes_viewOnly") {
          notes1_viewOnly = true;
        }
        if (storedNames[i].value === "notes_lock_viewOnly") {
          notes_lock1_viewOnly = true;
        }
        if (storedNames[i].value === "m_templete_viewOnly") {
          m_templete1_viewOnly = true;
        }
        if (storedNames[i].value === "patient_referral_viewOnly") {
          patientRef_viewOnly = true;
        }

        //reports
        if (storedNames[i].value === "rep_v") {
          rep1 = true;
        }
        if (storedNames[i].value === "rep_v_2") {
          rep2 = true;
        }
        if (storedNames[i].value === "rep_v_3") {
          rep3 = true;
        }
        //billing

        if (storedNames[i].value === "bill_a_viewOnly") {
          bill_a1_viewOnly = true;
        }
        if (
          storedNames[i].value === "processCardTransactions" ||
          storedNames[i].value === "processCardTransactions_viewOnly"
        ) {
          processCardTransactions = true;
        }
        if (storedNames[i].value === "processCardTransactions_viewOnly") {
          processCardTransactions_viewOnly = true;
        }
        if (
          storedNames[i].value === "postPayments" ||
          storedNames[i].value === "postPayments_viewOnly"
        ) {
          postPayments = true;
        }
        if (storedNames[i].value === "postPayments_viewOnly") {
          postPayments_viewOnly = true;
        }
        if (storedNames[i].value === "bill_led_viewOnly") {
          bill_led1_viewOnly = true;
        }
        if (storedNames[i].value === "pat_statement_viewOnly") {
          pat_statement1_viewOnly = true;
        }
        if (storedNames[i].value === "coding_v_viewOnly") {
          coding1_viewOnly = true;
        }
        if (storedNames[i].value === "ins_claims_viewOnly") {
          ins_claims1_viewOnly = true;
        }
        //new start end

        if (
          storedNames[i].value === "demo_v" ||
          storedNames[i].value === "demo_v_viewOnly"
        ) {
          demo = true;
        }

        if (storedNames[i].value === "appt_v") {
          appt1 = true;
        }
        if (
          storedNames[i].value === "mesg" ||
          storedNames[i].value === "mesg_viewOnly"
        ) {
          mesg = true;
        }
        if (
          storedNames[i].value === "notes_v" ||
          storedNames[i].value === "notes_viewOnly"
        ) {
          notes = true;
        }
        if (storedNames[i].value === "drugs_v") {
          drugs = true;
        }
        if (storedNames[i].value === "bill_v") {
          bill = true;
        }
        if (
          storedNames[i].value === "coding_v" ||
          storedNames[i].value === "coding_v_viewOnly"
        ) {
          coding = true;
        }
        if (storedNames[i].value === "rep_v") {
          rep = true;
        }
        if (
          storedNames[i].value === "bill_a" ||
          storedNames[i].value === "bill_a_viewOnly"
        ) {
          bill_a = true;
        }
        if (storedNames[i].value === "bill_s") {
          bill_s = true;
        }
        if (storedNames[i].value === "pat_bal") {
          pat_bal = true;
        }
        if (storedNames[i].value === "users_v") {
          users = true;
        }
        if (storedNames[i].value === "users_s") {
          users_s = true;
        }
        if (storedNames[i].value === "bill_admin") {
          bill_admin = true;
        }
        if (storedNames[i].value === "acl_v") {
          acl = true;
        }
        if (
          storedNames[i].value === "pat_statement" ||
          storedNames[i].value === "pat_statement_viewOnly"
        ) {
          pat_statement = true;
        }
        if (
          storedNames[i].value === "bill_led" ||
          storedNames[i].value === "bill_led_viewOnly"
        ) {
          bill_led = true;
        }
        if (
          storedNames[i].value === "notes_lock" ||
          storedNames[i].value === "notes_lock_viewOnly"
        ) {
          notes_lock = true;
        }
        if (
          storedNames[i].value === "appt_a" ||
          storedNames[i].value === "appt_a_viewOnly"
        ) {
          appt_a = true;
        }
        if (storedNames[i].value === "ipad") {
          ipad = true;
        }
        if (storedNames[i].value === "erx") {
          erx = true;
        }
        if (
          storedNames[i].value === "contacts" ||
          storedNames[i].value === "contacts_viewOnly"
        ) {
          contacts = true;
        }
        if (
          storedNames[i].value === "pat_g" ||
          storedNames[i].value === "pat_g_viewOnly"
        ) {
          pat_g = true;
        }
        if (storedNames[i].value === "pat_analytics") {
          pat_analytics = true;
        }
        if (storedNames[i].value === "gadd_v") {
          gadd = true;
        }
        if (storedNames[i].value === "pat_share") {
          pat_share = true;
        }
        if (storedNames[i].value === "pat_emergency") {
          pat_emergency = true;
        }
        if (
          storedNames[i].value === "m_templete" ||
          storedNames[i].value === "m_templete_viewOnly"
        ) {
          m_templete = true;
        }

        if (
          storedNames[i].value === "ins_claims" ||
          storedNames[i].value === "ins_claims_viewOnly"
        ) {
          ins_claims = true;
        }
        if (storedNames[i].value === "gm_v") {
          gm = true;
        }
        if (storedNames[i].value === "finance_reports") {
          finance_reports = true;
        }
        if (storedNames[i].value === "ref_source") {
          ref_source = true;
        }
        if (storedNames[i].value === "practice_groups") {
          practice_groups = true;
        }

        if (
          storedNames[i].value === "patient_referral" ||
          storedNames[i].value === "patient_referral_viewOnly"
        ) {
          patient_referral = true;
        }
        if (
          storedNames[i].value === "show_notification" ||
          storedNames[i].value === "show_notification_viewOnly"
        ) {
          show_notification = true;
        }
        if (
          storedNames[i].value === "fax" ||
          storedNames[i].value === "fax_viewOnly"
        ) {
          fax = true;
        }
      }
    }

    var permis = {
      appt1: appt1,
      viewAuditLog: viewAuditLog,
      manageAppointment_BillingProfile: manageAppointment_BillingProfile,
      setProviderAvailability: setProviderAvailability,
      accessPracticeDashboard: accessPracticeDashboard,

      demo: demo,
      appt: appt,
      mesg: mesg,
      notes: notes,
      drugs: drugs,
      bill: bill,
      coding: coding,
      rep: rep,
      bill_a: bill_a,
      pat_bal: pat_bal,
      users: users,
      users_s: users_s,
      bill_admin: bill_admin,
      acl: acl,
      pat_statement: pat_statement,
      bill_led: bill_led,
      notes_lock: notes_lock,
      appt_a: appt_a,
      ipad: ipad,
      erx: erx,
      contacts: contacts,
      pat_g: pat_g,
      pat_analytics: pat_analytics,
      gadd: gadd,
      pat_share: pat_share,
      pat_emergency: pat_emergency,
      m_templete: m_templete,
      ins_claims: ins_claims,
      gm: gm,
      bill_s: bill_s,
      finance_reports: finance_reports,
      ref_source: ref_source,
      practice_groups: practice_groups,
      show_notification: show_notification,
      patient_referral: patient_referral,
      fax: fax,

      rep3: rep3,
      rep2: rep2,
      rep1: rep1,
      managePatientEducation: managePatientEducation,
      manageAdministrationSettings: manageAdministrationSettings,
      setSchedulingPreferences: setSchedulingPreferences,
      configureBillingServices: configureBillingServices,
      manageAccountSettings: manageAccountSettings,

      //viewOnly
      viewAuditLog_viewOnly: viewAuditLog_viewOnly,
      configureBillingServices_viewOnly: configureBillingServices_viewOnly,
      manageAccountSettings_viewOnly: manageAccountSettings_viewOnly,
      rep3_viewOnly: rep3_viewOnly,
      rep2_viewOnly: rep2_viewOnly,
      processCardTransactions: processCardTransactions,
      processCardTransactions_viewOnly: processCardTransactions_viewOnly,
      postPayments_viewOnly: postPayments_viewOnly,
      postPayments: postPayments,
      manageAppointment_BillingProfile_viewOnly:
        manageAppointment_BillingProfile_viewOnly,
      setProviderAvailability_viewOnly: setProviderAvailability_viewOnly,
      accessPracticeDashboard_viewOnly: accessPracticeDashboard_viewOnly,
      managePatientEducation_viewOnly: managePatientEducation_viewOnly,

      coding1_viewOnly: coding1_viewOnly,
      rep1_viewOnly: rep1_viewOnly,
      bill_a1_viewOnly: bill_a1_viewOnly,
      pat_statement1_viewOnly: pat_statement1_viewOnly,
      bill_led1_viewOnly: bill_led1_viewOnly,
      notes_lock1_viewOnly: notes_lock1_viewOnly,
      appt_a1_viewOnly: appt_a1_viewOnly,
      contacts1_viewOnly: contacts1_viewOnly,
      pat_g1_viewOnly: pat_g1_viewOnly,
      m_templete1_viewOnly: m_templete1_viewOnly,
      show_noti_viewOnly: show_noti_viewOnly,
      patientRef_viewOnly: patientRef_viewOnly,
      fax_perm_viewOnly: fax_perm_viewOnly,
      manageAdministrationSettings_viewOnly:
        manageAdministrationSettings_viewOnly,
      setSchedulingPreferences_viewOnly: setSchedulingPreferences_viewOnly,

      demo1_viewOnly: demo1_viewOnly,
      appt1_viewOnly: appt1_viewOnly,
      mesg1_viewOnly: mesg1_viewOnly,
      notes1_viewOnly: notes1_viewOnly,
      ins_claims1_viewOnly: ins_claims1_viewOnly,
    };

    let permis_encrypt = Encrypt_Value(permis, "vozo");
    localStorage.setItem("setroles", permis_encrypt);
    sets_role(permis);
    if (token) {
      axiosInstance
        .get("/vozo/provider/accounttype?uid=" + uid)
        .then((res) => {
          let data = Decrypt_Value(res.data, "vozo");
          setAccount(data.account_type);
          setTrial(data.valid_upto_date);
        })
        .catch((err) => {
          console.log(err.message);
        });
    }
  }, []);

  useEffect(() => {
    if (!token) return;

    const uid =
      localStorage.getItem("user_id") &&
      Decrypt_Value(localStorage.getItem("user_id"), "vozo");

    if (!uid) return;

    axiosInstance
      .get(`/vozo/provider/whatsnew?uid=${uid}`)
      .then((response) => {
        const data = Decrypt_Value(response.data, "vozo");

        if (!data || (Array.isArray(data) && data.length === 0)) return;
        const currentPopupType = (data.popup_type || "navigate")
          .toString()
          .trim()
          .toLowerCase();

        const isNavigatePopup = currentPopupType === "navigate";
        const isVideoPopup =
          currentPopupType === "video" || currentPopupType === "watch_video";

        if (!isNavigatePopup && !isVideoPopup) {
          return;
        }

        setWhatsNewId(data.id);
        setPopupKey(data.popup_key || "");
        setPopupType(isVideoPopup ? "video" : "navigate");
        setButtonText(
          data.button_text || (isVideoPopup ? "Watch Video" : "Navigate"),
        );
        setlink(data.link?.replace(/^"+|"+$/g, "") || "");
        settittle(data.title || "");
        setDescription(data.description || "");
        setShowWhatsNew(true);

        whatsNewTimerRef.current = setTimeout(() => {
          closewhatsnew("timeout", data.id);
        }, 60000);
      })
      .catch((err) => {
        console.log("whatsnew error", err);
      });

    return () => {
      if (whatsNewTimerRef.current) {
        clearTimeout(whatsNewTimerRef.current);
      }
    };
  }, [token]);

  // useEffect(() => {
  //   const uid =
  //     localStorage.getItem("user_id") &&
  //     Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  //   axiosInstance
  //     .get(
  //       `/vozo/provider/whatsnew?currentdate=${moment().format(
  //         "YYYY-MM-DD",
  //       )}&uid=${uid}`,
  //     )
  //     .then((response) => {
  //       const data = Decrypt_Value(response.data, "vozo");
  //       if (data.length === 0) return;

  //       setShowWhatsNew(true);
  //       setlink(data.link?.replace(/^"+|"+$/g, ""));
  //       settittle(data.title);
  //       // setTimeLeft(data.time_left);

  //       // ⏱️ start timer ONLY after time_left is known
  //       whatsNewTimerRef.current = setTimeout(() => {
  //         closewhatsnew();
  //       }, 60000);
  //     });

  //   return () => {
  //     if (whatsNewTimerRef.current) {
  //       clearTimeout(whatsNewTimerRef.current);
  //     }
  //   };
  // }, []);

  // const closewhatsnew = () => {
  //   if (whatsNewTimerRef.current) {
  //     clearTimeout(whatsNewTimerRef.current);
  //   }

  //   setShowWhatsNew(false);

  //   const uid =
  //     localStorage.getItem("user_id") &&
  //     Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  //   axiosInstance.put(
  //     `/vozo/provider/updatewhatsnew?currentdate=${moment().format(
  //       "YYYY-MM-DD",
  //     )}&uid=${uid}`,
  //   );
  // };

  const closewhatsnew = (
    status = "closed",
    selectedWhatsNewId = whatsNewId,
  ) => {
    if (whatsNewTimerRef.current) {
      clearTimeout(whatsNewTimerRef.current);
    }

    setShowWhatsNew(false);

    const uid =
      localStorage.getItem("user_id") &&
      Decrypt_Value(localStorage.getItem("user_id"), "vozo");

    if (!uid || !selectedWhatsNewId) return;

    axiosInstance.put(
      `/vozo/provider/updatewhatsnew?uid=${uid}&whats_new_id=${selectedWhatsNewId}&status=${status}`,
    );
  };

  useEffect(() => {
    if (!token) return;

    const uid =
      localStorage.getItem("user_id") &&
      Decrypt_Value(localStorage.getItem("user_id"), "vozo");

    if (!uid) return;

    axiosInstance
      .get(`/vozo/userwelcomestatus?id=${uid}`)
      .then((res) => {
        const data = Decrypt_Value(res.data, "vozo");

        if (data.showPopup) {
          setPopupStep(data.currentStep);
          setShowPopup(true);
        } else {
          setShowPopup(false);
        }
      })
      .catch((err) => {
        console.log("userwelcomestatus error", err);
      });
  }, []);

  useEffect(() => {
    let logo = "";
    let imgfile = "";
    const fetchNotesData = async () => {
      try {
        const res = await axiosInstance.post("/vozo/settingClinicalNotes");
        let temp_role = Decrypt_Value(res.data, "vozo");
        logo = temp_role[3]["gl_value"];

        setExtension(logo);
        setNotesData(temp_role);

        if (logo) {
          imgfile = {
            url: generateFileURL(fileTypes.profileimages, logo),
          };
          await fetchImageBase64(logo);
        }
      } catch (error) {
        setNotesData([]);
      }
    };
    if (token) {
      fetchNotesData();
    }

    const fetchImageBase64 = async () => {
      try {
        const res = await axiosInstance.post(
          "/vozo/document/img/base64",
          imgfile,
        );
        setBase64(res.data);
      } catch (error) {
        setBase64("");
      }
    };
  }, [localStorage.getItem("NewEncounter")]);

  let subPayment =
    localStorage.getItem("subpaid_status") &&
    Decrypt_Value(localStorage.getItem("subpaid_status"), "vozo");

  if (timer == 0) {
    logout(userid, true);
  }
  const accountStatusFlag = localStorage.getItem("account_status_flag");
  if (accountStatusFlag === "deleted") {
    return (
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route exact path="/reactivate" render={() => <ReActivate />} />
          <Redirect to="/reactivate" />
        </Switch>
      </Suspense>
    );
  } else if (
    accountStatusFlag === "inactive" &&
    !(
      location_path.pathname.includes("/settings/deleteaccount") ||
      location_path.pathname.includes("/settings/SecureData") ||
      location_path.pathname.includes("/settings/acknowledgement")
    )
  ) {
    return (
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route exact path="/ReNewPage" render={() => <ReNewPage />} />
          <Route exact path="/DataExport" render={() => <DataExport />} />

          <Redirect to="/ReNewPage" />
        </Switch>
      </Suspense>
    );
  } else {
    ////////////////////session check code starts here//////////////////////////////////////////////////
    const CurrTime = moment().utc();

    const token_exp_time = moment.utc(localStorage.getItem("login_time"));
    if (token_exp_time.isBefore(CurrTime)) {
      // logout(userid, true);
    }

    ////////////////////session check code ends here//////////////////////////////////////////////////

    if (
      !token ||
      ConfToken === "Request failed with status code 401" ||
      hideTopNavbar
    ) {
      return (
        <Suspense fallback={<Loader />}>
          <Switch>
            <Route exact path="/" render={() => <Login />} />
            <Route
              exact
              path="/login/ForgotPassword"
              render={() => (
                <ForgotPassword
                  saveMail={(x) => {
                    setMailAddress(x);
                    history.push("/login/checkyouremail");
                  }}
                />
              )}
            />
            <Route
              exact
              path="/login/checkyouremail"
              render={() => <CheckYourEmail mailID={mailAddress} />}
            />
            <Route
              exact
              path="/login/SetNewPassword/:code/:id"
              render={() => (
                <SetNewPassword sendDetails={(x) => setSendToContinue(x)} />
              )}
            />
            <Route
              exact
              path="/login/ResetSuccessfull"
              render={() => <ResetSuccessfull sendData={sendToContinue} />}
            />

            <Route render={() => <Redirect to="/" />} />
          </Switch>
        </Suspense>
      );
    } else if (twoStepVerify === "1") {
      return (
        <Suspense fallback={<Loader />}>
          <Switch>
            <Route exact path="/" render={() => <Login />} />
            <Route
              exact
              path="/twostepverify"
              render={() => <TwoStepVerification />}
            />
          </Switch>
        </Suspense>
      );
    } else if (token && expired_days < -120 && !temp_user) {
      return (
        <Switch>
          <Route exact path="/" render={() => <AccountManagement />} />
          <Route
            exact
            path="/accountverify"
            render={() => <AccountVerification />}
          />
          <Route
            exact
            path="/otpverification"
            render={() => <OtpVerification />}
          />
          <Route
            exact
            path="/verificationdone"
            render={() => <VerificationDone />}
          />
        </Switch>
      );
    } else if (
      token &&
      (ConfToken !== undefined ||
        ConfToken !== "Request failed with status code 401")
      // && subPayment.status === "paid"
    )
      return (
        <div className="App">
          <Suspense fallback={null}>
            {/* <WhatsNew
              visible={showWhatsNew}
              onClose={closewhatsnew}
              title={title}
              buttonText="Watch Video"
              onButtonClick={() => {
                closewhatsnew();
                window.open(link, "_blank", "noopener,noreferrer");
              }}
            /> */}
            <WhatsNew
              visible={showWhatsNew}
              onClose={() => closewhatsnew("closed")}
              title={title}
              description={description}
              buttonText={buttonText}
              onButtonClick={() => {
                const currentPopupType = (popupType || "navigate")
                  .toString()
                  .trim()
                  .toLowerCase();

                if (currentPopupType === "navigate") {
                  closewhatsnew("clicked");

                  const path = getWhatsNewRedirectPath(popupKey);

                  if (path) {
                    history.push(path);
                  }

                  return;
                }

                if (
                  (currentPopupType === "video" ||
                    currentPopupType === "watch_video") &&
                  link
                ) {
                  window.open(link, "_blank", "noopener,noreferrer");
                  closewhatsnew("clicked");
                }
              }}
            />
          </Suspense>
          {showSessionModal && (
            <StayLoggedIn
              show={showSessionModal}
              popupSeconds={popupSeconds}
              onStay={refreshToken}
              onLogout={() => {
                localStorage.clear();
                window.location.href = "/";
              }}
            />
          )}
          {showPopup && !isAuthPage && (
            <AddClinicalProfile
              step={popupStep}
              onStepChange={(nextStep) => setPopupStep(nextStep)}
              onClose={() => {
                setShowPopup(false);
                setPopupStep(0);
              }}
            />
          )}
          {showUpdatePaymentModal && !isAuthPage && (
            <UpdatePaymentMethodModal
              show={showUpdatePaymentModal}
              onHide={() => setShowUpdatePaymentModal(false)}
            />
          )}
          {!hideTopNavbar && (
            <TopNav
              ref={SettingRef}
              tref={TasksRef}
              calRefHandle={handleRefCalls}
              reqDrop={reqDrop}
              DropReq={handleDropReq}
              refid={reqDrop ? refid : ""}
              refreshPatient={refreshPatient}
            />
          )}
          <div className="app-body">
            <Suspense fallback={<Loader />}>
              <Switch>
                {s_role.notes ? (
                  <Route
                    exact
                    path="/clinicalnotes"
                    render={() => (
                      <EditNotes
                        setSrc={(a) => {
                          handleframesrc(a);
                        }}
                        notelock={noteLock}
                        handledata={(b, c, d, e, f, g) => {
                          handleNotesData(b, c, d, e, f, g);
                        }}
                        source={iframesrc}
                        lock={noteLock}
                        setLock={(x) => {
                          handleNotesLock(x);
                        }}
                        rows={noteinfo}
                        encounter={noteid}
                        data={notedata}
                        data1={notedata1}
                        st={nottime}
                        date={notedate}
                        base64={base64}
                        notesData={notesData}
                        extension={extension}
                      />
                    )}
                  />
                ) : (
                  <Route
                    exact
                    path="/clinicalnotes"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.notes ? (
                  <Route
                    exact
                    path="/clinicalnotes/previewnote"
                    render={() => (
                      <Previewnote
                        base64={base64}
                        notesData={notesData}
                        extension={extension}
                        source={iframesrc}
                        lock={noteLock}
                        setLock={(x) => {
                          handleNotesLock(x);
                        }}
                        setSrc={(x) => {
                          handleframesrc(x);
                        }}
                        rows={noteinfo}
                        encounter={noteid}
                        data={notedata}
                        data1={notedata1}
                        st={nottime}
                        date={notedate}
                      />
                    )}
                  />
                ) : (
                  <Route
                    exact
                    path="/clinicalnotes/previewnote"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.configureBillingServices ? (
                  <Route
                    exact
                    path="/settings/payersearch"
                    render={() => <PayerSearch />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/payersearch"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.manageAccountSettings ? (
                  <Route
                    exact
                    path="/settings/securitydocument"
                    render={() => <SecurityDocument />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/securitydocument"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.managePatientEducation ? (
                  <Route
                    exact
                    path="/patient/patienteducation"
                    render={() => <PatientEducation />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/patienteducation"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.managePatientEducation ? (
                  <Route
                    exact
                    path="/patient/membershipplan"
                    render={() => <MembershipPlan />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/membershipplan"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.accessPracticeDashboard ? (
                  <Route
                    exact
                    path="/schedule/appdashboard"
                    render={() => <AppDashboard />}
                  />
                ) : (
                  <Route
                    exact
                    path="/schedule/appdashboard"
                    render={() => <AccessDenied />}
                  />
                )}

                {/* saravanana 31.3.22 8:00 start */}
                {(account != "0" && account <= "3") ||
                (account == "0" && trial == true) ? (
                  <Route
                    exact
                    path="/popups/Tasks"
                    render={() => <Tasks TaskRef={TopNavTasks} />}
                  />
                ) : (
                  <Route
                    exact
                    path="/popups/Tasks"
                    render={() => <UpgradeRequired />}
                  />
                )}
                {/* saravanana 31.3.22 8:00 end */}

                {/* ----------------------------Common Pages End---------------------------------------------------- */}

                {/* --------------------------------------Demo Start------------------------------ */}

                {s_role.demo ? (
                  <Route
                    exact
                    path="/patient/nav/:nav"
                    render={() => <PatientList refreshList={refreshList} />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/nav/:nav"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.demo ? (
                  <Route
                    exact
                    path="/patient/patientlist"
                    render={() => <PatientList refreshList={refreshList} />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/patientlist"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.demo ? (
                  <Route
                    exact
                    path="/patient/patientGroup"
                    render={() => <PatientGroup refreshList={refreshList} />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/patientGroup"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.demo ? (
                  <Route
                    exact
                    path="/patient/DietRecommendation"
                    render={() => (
                      <DietRecommendation refreshList={refreshList} />
                    )}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/DietRecommendation"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.demo ? (
                  <Route
                    exact
                    path="/patient/Orderset"
                    render={() => <Orderset refreshList={refreshList} />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/Orderset"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.demo ? (
                  <Route
                    exact
                    path="/patient/Orderset/create"
                    render={() => <CreateOrderset refreshList={refreshList} />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/Orderset/create"
                    render={() => <AccessDenied />}
                  />
                )}
                <Route
                  exact
                  path="/patient/BatchEligibility"
                  render={() => <BatchEligibility />}
                />

                {/* saravanana 31.3.22 8:00 start */}
                {/* { ? ( */}
                <Route
                  exact
                  path="/patient/patientflag"
                  render={() => <PatientFlag />}
                />

                <Route
                  exact
                  path="/patient/demographics/:pid/"
                  render={() => <Demographics />}
                />

                <Route
                  exact
                  path="/patient/careSummary/:pid/"
                  render={() => <CareSummary />}
                />

                {/* Insurance Coverage */}

                <Route
                  exact
                  path="/patient/insuranceCoverage/:pid"
                  render={() => <InsuranceCoverage />}
                />

                <Route
                  exact
                  path="/patient/appointment/:pid"
                  render={() => <Appointment />}
                />
                
                <Route
                  exact
                  path="/patient/encounternotes/:pid"
                  render={() => <EncounterNotes />}
                />

                <Route
                  exact
                  path="/patient/billandInsurance/:pid"
                  render={() => <PatientBillInsurance />}
                />

                <Route
                  exact
                  path="/patient/flowsheet/:pid"
                  render={() => <FlowSheet />}
                />

                <Route
                  exact
                  path="/patient/problems/:pid"
                  render={() => <Problems />}
                />

                <Route
                  exact
                  path="/patient/allergies/:pid"
                  render={() => <Allergies />}
                />

                <Route
                  exact
                  path="/patient/medication/:pid"
                  render={() => <Medication />}
                />

                <Route exact path="/patient/lab/:pid" render={() => <Lab />} />

                <Route
                  exact
                  path="/patient/familyhistory/:pid"
                  render={() => <FamilyHistory />}
                />

                <Route
                  exact
                  path="/patient/pastmedicalhistory/:pid"
                  render={() => <PastMedicalHistory />}
                />
                <Route
                  exact
                  path="/patient/episodemanagement/:pid"
                  render={() => <EpisodeManagement />}
                />


                <Route
                  exact
                  path="/patient/episodemanagement/:pid"
                  render={() => <EpisodeManagement />}
                />

                <Route
                  exact
                  path="/patient/growthchart/:pid"
                  render={() => <GrowthChart />}
                />

                <Route
                  exact
                  path="/patient/immunization/:pid"
                  render={() => <Immunization />}
                />

                <Route
                  exact
                  path="/patient/documents/:pid"
                  render={() => <Documents />}
                />
                {/* careplan */}
                <Route
                  exact
                  path="/patient/careplan/:pid"
                  render={() => <CarePlan />}
                />

                <Route
                  exact
                  path="/patient/treatmentplan/:pid"
                  render={() => <TreatmentPlan />}
                />
                <Route
                  exact
                  path="/patient/monitoring/:pid"
                  render={() => <Monitoring />}
                />

                <Route
                  exact
                  path="/patient/riskassessment/:pid"
                  render={() => <HealthScreening />}
                />

                <Route
                  exact
                  path="/patient/measures/:pid"
                  render={() => <Measures />}
                />

                <Route
                  exact
                  path="/patient/billinghistory/:pid"
                  render={() => <BillingHistory />}
                />

                <Route
                  exact
                  path="/patient/Patienttreatmentplanview/:pid/:id"
                  render={() => <Patienttreatmentplanview />}
                />

                <Route
                  exact
                  path="/patient/managemacrobutton"
                  render={() => <ManageMacroButton />}
                />
                <Route
                  exact
                  path="/patient/casemanagement"
                  render={() => <CaseManagement />}
                />
                <Route
                  exact
                  path="/patient/casemanagement/structure"
                  render={() => <CaseManagementStructure />}
                />
                <Route
                  exact
                  path="/patient/casemanagement-structure"
                  render={() => <CaseManagementStructure />}
                />

                {s_role.demo ? (
                  <Route
                    exact
                    path="/patient/preventiveguidelines"
                    render={() => <PreventiveGuidelines />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/preventiveguidelines"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.demo ? (
                  <Route
                    exact
                    path="/patient/electronicreports"
                    render={() => <ElectronicReports />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/electronicreports"
                    render={() => <AccessDenied />}
                  />
                )}

                <Route
                  exact
                  path="/patient/procedureorder/:pid"
                  render={() => <ProcedureOrder />}
                />
                <Route
                  exact
                  path="/patient/imaging/:pid"
                  render={() => <Imaging />}
                />

                <Route
                  exact
                  path="/patient/clientportalaccess/:pid"
                  render={() => <ClientPortalAccess />}
                />

                {s_role.notes ? (
                  <Route
                    exact
                    path="/patient/notetaking"
                    render={() => <NoteTaking />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/notetaking"
                    render={() => <AccessDenied />}
                  />
                )}

                <Route
                  exact
                  path="/patient/lifestyle/:pid"
                  render={() => <LifestyleDietRecommendation />}
                />

                <Route
                  exact
                  path="/patient/patientdashboard/:pid"
                  render={() => <PatientDashboard />}
                />

                {s_role.demo ? (
                  <Route
                    exact
                    path="/mednotes"
                    render={() => <MedEditNote />}
                  />
                ) : (
                  <Route
                    exact
                    path="/mednotes"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.demo ? (
                  <Route
                    exact
                    path="/review"
                    render={() => <ReviewEditNote />}
                  />
                ) : (
                  <Route exact path="/review" render={() => <AccessDenied />} />
                )}

                {s_role.demo ? (
                  <Route
                    exact
                    path="/medall"
                    render={() => <MedAllEditNote />}
                  />
                ) : (
                  <Route exact path="/medall" render={() => <AccessDenied />} />
                )}

                {s_role.demo ? (
                  <Route
                    exact
                    path="/physical"
                    render={() => <PhysicalEditNote />}
                  />
                ) : (
                  <Route
                    exact
                    path="/physical"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.demo ? (
                  <Route exact path="/plan" render={() => <PlanEditNote />} />
                ) : (
                  <Route exact path="/plan" render={() => <AccessDenied />} />
                )}
                {s_role.demo ? (
                  <Route
                    exact
                    path="/assessment"
                    render={() => <AssessmentEditNote />}
                  />
                ) : (
                  <Route
                    exact
                    path="/assessment"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.demo ? (
                  <Route
                    exact
                    path="/subject"
                    render={() => <SubjectEditNote />}
                  />
                ) : (
                  <Route
                    exact
                    path="/subject"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.demo ? (
                  <Route
                    exact
                    path="/object"
                    render={() => <ObjectEditNote />}
                  />
                ) : (
                  <Route exact path="/object" render={() => <AccessDenied />} />
                )}

                {s_role.fax ? (
                  <Route
                    exact
                    path="/patient/IncomingFax"
                    render={() => <Incomingfax />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/IncomingFax"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.fax ? (
                  <Route
                    exact
                    path="/patient/OutgoingFax"
                    render={() => <OutgoingFax />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/OutgoingFax"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.fax ? (
                  <Route
                    exact
                    path="/patient/IncomingFax/IncomingFaxindex/:To"
                    render={() => <IncomingFaxindex />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/IncomingFax/IncomingFaxindex/:To"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.fax ? (
                  <Route
                    exact
                    path="/patient/OutgoingFax/OutgoingFaxindex/:To"
                    render={() => <OutgoingFaxindex />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/OutgoingFax/OutgoingFaxindex/:To"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.patient_referral ? (
                  <Route
                    exact
                    path="/patient/referralmanageMent"
                    render={() => <ReferralManagement />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/referralmanageMent"
                    render={() => <AccessDenied />}
                  />
                )}

                {/* --------------------------------------Demo End------------------------------ */}

                {/* --------------------------------------Appt Start------------------------------ */}
                {/* {s_role.appt ? ( */}
                <Route
                  exact
                  path="/"
                  render={() => (
                    <Calender
                      calRefresh={calRefresh}
                      Drop={() => {
                        setReqDrop(!reqDrop);
                      }}
                      setRef={(x) => {
                        setRefId(x);
                      }}
                    />
                  )}
                />

                <Route
                  exact
                  path="/schedule/nav/:nav"
                  render={() => (
                    <Calender
                      calRefresh={calRefresh}
                      Drop={() => {
                        setReqDrop(!reqDrop);
                      }}
                      setRef={(x) => {
                        setRefId(x);
                      }}
                    />
                  )}
                />

                <Route
                  exact
                  path="/schedule/calender"
                  render={() => (
                    <Calender
                      calRefresh={calRefresh}
                      Drop={() => {
                        setReqDrop(!reqDrop);
                      }}
                      setRef={(x) => {
                        setRefId(x);
                      }}
                    />
                  )}
                />

                <Route
                  exact
                  path="/schedule/waitlist"
                  render={() => <AppointmentWaitlist />}
                />

                {s_role.manageAppointment_BillingProfile ? (
                  <Route
                    exact
                    path="/schedule/appprofiles"
                    render={() => <AppProfiles />}
                  />
                ) : (
                  <Route
                    exact
                    path="/schedule/appprofiles"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.manageAppointment_BillingProfile ? (
                  <Route
                    exact
                    path="/schedule/billingprofiles"
                    render={() => <BillingProfiles />}
                  />
                ) : (
                  <Route
                    exact
                    path="/schedule/billingprofiles"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.accessPracticeDashboard ? (
                  <Route
                    exact
                    path="/schedule/practicedashboard"
                    render={() => <PracticeDashboard />}
                  />
                ) : (
                  <Route
                    exact
                    path="/schedule/practicedashboard"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.viewAuditLog ? (
                  <Route
                    exact
                    path="/schedule/auditlog"
                    render={() => <AuditLog />}
                  />
                ) : (
                  <Route
                    exact
                    path="/schedule/auditlog"
                    render={() => <AccessDenied />}
                  />
                )}
                <Route
                  exact
                  path="/schedule/encryptDecrypt"
                  render={() => <EncryptDecryptComp />}
                />
                {s_role.setProviderAvailability ? (
                  <Route
                    exact
                    path="/schedule/apptemplate"
                    render={() => <AppTemplate />}
                  />
                ) : (
                  <Route
                    exact
                    path="/schedule/apptemplate"
                    render={() => <AccessDenied />}
                  />
                )}

                <Route
                  exact
                  path="/settings/acknowledgement/"
                  render={() => <Acknowledgement />}
                />

                {/* --------------------------------------Appt End------------------------------ */}

                {/* --------------------------------------Bill start----------------------------------- */}

                {s_role.ins_claims ? (
                  <Route
                    exact
                    path="/billing/nav/:nav"
                    render={() => <InsuranceClaim />}
                  />
                ) : (
                  <Route
                    exact
                    path="/billing/nav/:nav"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.pat_statement ? (
                  <Route
                    exact
                    path="/billing/patientstatement"
                    render={() => <PatientStatement />}
                  />
                ) : (
                  <Route
                    exact
                    path="/billing/patientstatement"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/productprocedure"
                    render={() => <ProductProcedure />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/productprocedure"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.rep ? (
                  <Route
                    exact
                    path="/report/productprocedures/:code_type/:code/:fromdt/:todt"
                    render={() => <ProductProcedures />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/productprocedures/:code_type/:code/:fromdt/:todt"
                    render={() => <AccessDenied />}
                  />
                )}
                {(window.location.hostname
                  .toLowerCase()
                  .includes("production") ||
                  window.location.hostname === "localhost" ||
                  window.location.hostname === "127.0.0.1") && (
                  <Route
                    exact
                    path="/billing/feeschedule"
                    render={() => <FeeSchedule />}
                  />
                )}

                {s_role.ins_claims ? (
                  <Route
                    exact
                    path="/billing/insuranceclaim"
                    render={() => <InsuranceClaim />}
                  />
                ) : (
                  <Route
                    exact
                    path="/billing/insuranceclaim"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.ins_claims ? (
                  <Route
                    exact
                    path="/billing/GenerateClaimProcess"
                    render={() => <GenerateForm />}
                  />
                ) : (
                  <Route
                    exact
                    path="/billing/GenerateClaimProcess"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.bill_led ? (
                  <Route
                    exact
                    path="/billing/patientbalance"
                    render={() => <PatientBalance />}
                  />
                ) : (
                  <Route
                    exact
                    path="/billing/patientbalance"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.postPayments ? (
                  <Route exact path="/billing/eob" render={() => <Eob />} />
                ) : (
                  <Route
                    exact
                    path="/billing/eob"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.processCardTransactions ? (
                  <Route
                    exact
                    path="/report/cardtransactions"
                    render={() => <CardTransactions />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/cardtransactions"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.postPayments ? (
                  <Route exact path="/billing/era" render={() => <Era />} />
                ) : (
                  <Route
                    exact
                    path="/billing/era"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.postPayments ? (
                  <Route
                    exact
                    path="/billing/era/vieweratable"
                    render={() => <ViewEratable />}
                  />
                ) : (
                  <Route
                    exact
                    path="/billing/era/vieweratable"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.coding ? (
                  <Route
                    exact
                    path="/billing/EobTableEdit/:eid"
                    render={() => <EobTableEdit />}
                  />
                ) : (
                  <Route
                    exact
                    path="/billing/EobTableEdit/:ei"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.coding ? (
                  <Route
                    exact
                    path="/billing/EobTableEdit"
                    render={() => <EobTableEdit />}
                  />
                ) : (
                  <Route
                    exact
                    path="/billing/EobTableEdit"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.coding ? (
                  <Route
                    exact
                    path="/billing/EobInsurance/:eid"
                    render={() => <EobInsurance />}
                  />
                ) : (
                  <Route
                    exact
                    path="/billing/EobInsurance/:eid"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.coding ? (
                  <Route
                    exact
                    path="/billing/PatientPaymentInvoice"
                    render={() => <PatientPaymentInvoice />}
                  />
                ) : (
                  <Route
                    exact
                    path="/billing/PatientPaymentInvoice"
                    render={() => <AccessDenied />}
                  />
                )}
                <Route path="/scoreboard/:pid/:sid" component={Scoreboard} />
                <Route path="/activitylog/:pid/:sid" component={ActivityLog} />
                {/* --------------------------------------Bill end----------------------------------- */}

                {/* --------------------------------------Coding start----------------------------------- */}
                {s_role.coding ? (
                  <Route
                    exact
                    path="/billing/patientpayment"
                    render={() => <PatientPayment />}
                  />
                ) : (
                  <Route
                    exact
                    path="/billing/patientpayment"
                    render={() => <AccessDenied />}
                  />
                )}
                {/* --------------------------------------Coding end----------------------------------- */}

                {/* --------------------------------------rep start----------------------------------- */}

                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/nav/:nav"
                    render={() => <BillingSummary />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/nav/:nav"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/BillingSummary"
                    render={() => <BillingSummary />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/BillingSummary"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.rep1 ? (
                  <Route
                    exact
                    path="/report/PriorAuthorization"
                    render={() => <PriorAuthorization />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/PriorAuthorization"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.rep1 ? (
                  <Route
                    exact
                    path="/report/EligibilityReport"
                    render={() => <EligibilityReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/EligibilityReport"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.rep1 ? (
                  <Route
                    exact
                    path="/report/OutgoingPrescription"
                    render={() => <OutgoingPrescription />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/OutgoingPrescription"
                    render={() => <AccessDenied />}
                  />
                )}
                <Route
                  exact
                  path="/report/IncomeAllocationReport"
                  render={() => <IncomeAllocationReport />}
                />
                {s_role.rep3 ? (
                  <Route
                    exact
                    path="/report/appointments"
                    render={() => <Appointments />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/appointments"
                    render={() => <AccessDenied />}
                  />
                )}
                {/* <Route
                  exact
                  path="/report/groupattendance"
                  render={() => <GroupAttendanceReport />}
                /> */}
                {s_role.rep2 ? (
                  <Route exact path="/report/aging" render={() => <Aging />} />
                ) : (
                  <Route
                    exact
                    path="/report/aging"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.rep3 ? (
                  <Route exact path="/report/User" render={() => <User />} />
                ) : (
                  <Route
                    exact
                    path="/report/User"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/Invoice"
                    render={() => <Invoice />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/Invoice"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/refundreport"
                    render={() => <RefundReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/refundreport"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.rep3 ? (
                  <Route
                    exact
                    path="/report/Reminder"
                    render={() => <Reminder />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/Reminder"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.rep3 ? (
                  <Route
                    exact
                    path="/report/ProductivityReport"
                    render={() => <ProductivityReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/ProductivityReport"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.rep1 ? (
                  <Route
                    exact
                    path="/report/PatientReport"
                    render={() => <PatientReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/PatientReport"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/daySheet"
                    render={() => <DaySheet />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/daySheet"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/Remittance"
                    render={() => <Remittance />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/Remittance"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/clinicalreport"
                    render={() => <ClinicalReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/clinicalreport"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/groupattendance"
                    render={() => <GroupAttendanceReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/groupattendance"
                    render={() => <AccessDenied />}
                  />
                )}

                {/* --------------------------------------clinicalreport start----------------------------------- */}
                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/clinicalreport"
                    render={() => <ClinicalReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/clinicalreport"
                    render={() => <AccessDenied />}
                  />
                )}

                {/* AccountReceivables Report */}
                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/AccountReceivableReport"
                    render={() => <AccountReceivableReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/AccountReceivableReport"
                    render={() => <AccessDenied />}
                  />
                )}

                {/* Unapplied Credit Report */}
                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/UnappliedCreditReport"
                    render={() => <UnappliedCreditReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/UnappliedCreditReport"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/superbillreport"
                    render={() => <SuperbillReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/superbillreport"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/OutstandingBalanceReport"
                    render={() => <OutstandingBalanceReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/OutstandingBalanceReport"
                    render={() => <AccessDenied />}
                  />
                )}
                {/* Write Off/Adjustment Report */}
                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/WriteOffAdjustmentReport"
                    render={() => <WriteOffAdjustmentReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/WriteOffAdjustmentReport"
                    render={() => <AccessDenied />}
                  />
                )}

                {/* Denial Analysis Report */}

                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/DenialAnalysisReport"
                    render={() => <DenialAnalysisReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/DenialAnalysisReport"
                    render={() => <AccessDenied />}
                  />
                )}

                {/* RejectionAnalysisReport */}
                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/RejectionAnalysisReport"
                    render={() => <RejectionAnalysisReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/RejectionAnalysisReport"
                    render={() => <AccessDenied />}
                  />
                )}

                {/* Claim Submission Report */}

                {s_role.rep2 ? (
                  <Route
                    exact
                    path="/report/ClaimSubmissionReport"
                    render={() => <ClaimSubmissionReport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/report/ClaimSubmissionReport"
                    render={() => <AccessDenied />}
                  />
                )}

                {/* --------------------------------------Superbill report start----------------------------------- */}

                {/* --------------------------------------Superbill report end----------------------------------- */}

                {/* --------------------------------------rep end----------------------------------- */}

                {/* ---------------------------------------users start---------------------------------------- */}
                {s_role.manageAccountSettings ? (
                  <Route
                    exact
                    path="/settings/nav/:nav"
                    render={() => <SettingsMyProfile TopNavRef={TopNavProps} />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/nav/:nav"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.configureBillingServices ? (
                  <Route
                    exact
                    path="/settings/lab"
                    render={() => <LabSettings />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/lab"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.manageAccountSettings ? (
                  <Route
                    exact
                    path="/settings/settingsmyprofile"
                    render={() => <SettingsMyProfile TopNavRef={TopNavProps} />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/settingsmyprofile"
                    render={() => <AccessDenied />}
                  />
                )}
                {/* {s_role.configureBillingServices ? (
                    <Route
                      exact
                      path="/settings/integrations"
                      render={() => <Integrations />}
                    />
                  ) : (
                    <Route
                      exact
                      path="/settings/integrations"
                      render={() => <AccessDenied />}
                    />
                  )} */}

                {s_role.configureBillingServices ? (
                  <Route
                    exact
                    path="/settings/settingservice"
                    render={() => <SettingService />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/settingservice"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.manageAccountSettings ? (
                  <Route
                    exact
                    path="/settings/security"
                    render={() => <Security />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/security"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.manageAccountSettings ? (
                  <Route
                    exact
                    path="/settings/myplan"
                    render={() => <MyPlan />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/myplan"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.manageAccountSettings ? (
                  <Route
                    exact
                    path="/settings/settingpracticeinfo"
                    render={() => <SettingPracticeInfo />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/settingpracticeinfo"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.configureBillingServices ? (
                  <Route
                    exact
                    path="/settings/settingbilling"
                    render={() => <SettingBilling />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/settingbilling"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.setSchedulingPreferences ? (
                  <Route
                    exact
                    path="/settings/calendersettings"
                    render={() => <CalenderSettings />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/calendersettings"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.setSchedulingPreferences ? (
                  <Route
                    exact
                    path="/settings/onlineschedule"
                    render={() => <OnlineScheduleSettings />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/onlineschedule"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.manageAccountSettings ? (
                  <Route
                    exact
                    path="/settings/timezonesettings"
                    render={() => <TimeZoneSettings />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/timezonesettings"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.setSchedulingPreferences ? (
                  <Route
                    exact
                    path="/settings/appointmentreminder"
                    render={() => <AppointmentReminder />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/appointmentreminder"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.setSchedulingPreferences ? (
                  <Route
                    exact
                    path="/settings/patientportal/:mark"
                    render={() => <PatientPortalSetting />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/patientportal/:mark"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.setSchedulingPreferences ? (
                  <Route
                    exact
                    path="/settings/notificationsettings"
                    render={() => <NotificationSettings />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/notificationsettings"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.manageAccountSettings ? (
                  <Route
                    exact
                    path="/settings/Users"
                    render={() => <Users />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/Users"
                    render={() => <AccessDenied />}
                  />
                )}
                {/* ---------------------------------------users end------------------------------------------- */}

                {/* ------------------------------------------acl Start---------------------------------------- */}
                {s_role.manageAccountSettings ? (
                  <Route
                    exact
                    path="/settings/Roles"
                    render={() => <RolesMain />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/Roles"
                    render={() => <AccessDenied />}
                  />
                )}
                {/* ------------------------------------------acl End---------------------------------------- */}

                {/* -------------------------------------------erx start------------------------------------------- */}

                {s_role.manageAdministrationSettings ? (
                  <Route
                    exact
                    path="/patient/senderx/:pid/:ch"
                    render={() => <SendErx />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/senderx/:pid/:ch"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.manageAdministrationSettings ? (
                  <Route
                    exact
                    path="/patient/senderxedit/:pid"
                    render={() => <SendErxEdit />}
                  />
                ) : (
                  <Route
                    exact
                    path="/patient/senderxedit/:pid"
                    render={() => <AccessDenied />}
                  />
                )}

                {s_role.manageAdministrationSettings ? (
                  <Route
                    exact
                    path="/settings/Templates"
                    render={() => <Templates />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/Templates"
                    render={() => <AccessDenied />}
                  />
                )}

                {(window.location.hostname
                  .toLowerCase()
                  .includes("production") ||
                  window.location.hostname === "localhost" ||
                  window.location.hostname === "127.0.0.1") &&
                  (s_role.manageAdministrationSettings ? (
                    <Route
                      exact
                      path="/settings/Inventory"
                      render={() => <Inventory />}
                    />
                  ) : (
                    <Route
                      exact
                      path="/settings/Inventory"
                      render={() => <AccessDenied />}
                    />
                  ))}

                {s_role.manageAdministrationSettings ? (
                  <Route
                    exact
                    path="/settings/ERXsettings"
                    render={() => <ERXSetting />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/ERXsettings"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.manageAdministrationSettings ? (
                  <Route
                    exact
                    path="/settings/Dataimport/"
                    render={() => <Dataimport />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/Dataimport/"
                    render={() => <AccessDenied />}
                  />
                )}
                {s_role.configureBillingServices ? (
                  <Route
                    exact
                    path="/settings/integrations"
                    render={() => <Integrations />}
                  />
                ) : (
                  <Route
                    exact
                    path="/settings/itegrations"
                    render={() => <AccessDenied />}
                  />
                )}
                <Route
                  exact
                  path="/settings/SubscriptionExpired/"
                  render={() => <SubscriptionExpired />}
                />

                <Route
                  exact
                  path="/settings/accountsetup"
                  render={() => <AccountSetup />}
                />

                {/* <Route
                    exact
                    path="/settings/deleteaccount/:seperator"
                    render={() => <DeleteAccount />}
                  /> */}
                <Route
                  exact
                  path="/settings/deleteaccount/:seperator"
                  render={() => <DeleteAccountMain />}
                />
                <Route
                  exact
                  path="/settings/SecureData"
                  render={() => <SecureData />}
                />
                <Route
                  exact
                  path="/settings/acknowledgement/"
                  render={() => <Acknowledgement />}
                />

                <Route exact path="/dashboard" component={MainDashboard} />

                <Route render={() => <NotFound />} />
              </Switch>
            </Suspense>
          </div>
          <WenoSupport />

          {/* Global Phone Call Popup (Main App View) */}
          {phoneCallPopupData && (
            <PhoneCallPopup
              device={twilioDevice || twilioDeviceRef.current}
              callType={phoneCallPopupData.callType}
              incomingCall={phoneCallPopupData.incomingCall}
              patientName={phoneCallPopupData.patientName}
              phoneNumber={phoneCallPopupData.phoneNumber}
              appointmentId={phoneCallPopupData.appointmentId}
              patientId={phoneCallPopupData.patientId}
              providerId={phoneCallPopupData.providerId}
              onClose={closePhoneCallPopup}
            />
          )}
        </div>
      );
    else if (
      ((subPayment.status === null || subPayment.status === "open") &&
        ConfToken !== undefined) ||
      (token && expired_days < 0)
    )
      return (
        <div className="App">
          <TopNav
            ref={SettingRef}
            tref={TasksRef}
            calRefHandle={handleRefCalls}
            reqDrop={reqDrop}
            DropReq={handleDropReq}
            refid={reqDrop ? refid : ""}
          />
          <div className="app-body">
            <Suspense fallback={<Loader />}>
              <Switch>
                <Route exact path="/dashboard" component={MainDashboard} />
                <Route
                  exact
                  path="/"
                  render={() => (
                    <Calender
                      calRefresh={calRefresh}
                      Drop={() => {
                        setReqDrop(!reqDrop);
                      }}
                      setRef={(x) => {
                        setRefId(x);
                      }}
                    />
                  )}
                />
                <Route
                  exact
                  path="/schedule/calender"
                  render={() => (
                    <Calender
                      calRefresh={calRefresh}
                      Drop={() => {
                        setReqDrop(!reqDrop);
                      }}
                      setRef={(x) => {
                        setRefId(x);
                      }}
                    />
                  )}
                />
                <Route render={() => <Redirect to="/dashboard" />} />
              </Switch>
            </Suspense>
          </div>
          <WenoSupport />
        </div>
      );
  }
};

export default App;
